import { useClientSideSplitTreatments } from "@leafly-com/split-next";
import { useSelector } from "react-redux";

import { getCity, getState } from "redux/selectors/location";
import { getSplitKey } from "utils/split/getSplitKey";

export const useDispensariesLink = ({
  finderCityStateServerSideSplitEnabled = false,
  strainQueryParams = "",
}: {
  finderCityStateServerSideSplitEnabled?: boolean;
  strainQueryParams?: string;
} = {}) => {
  const city = useSelector(getCity);
  const state = useSelector(getState);

  const { treatments, isLoading } = useClientSideSplitTreatments(
    "UseCityStateFinder_flag",
    getSplitKey()
  );
  const finderCityStateSplitEnabled = finderCityStateServerSideSplitEnabled
    ? finderCityStateServerSideSplitEnabled
    : !isLoading && treatments.UseCityStateFinder_flag.treatment === "on";

  return finderCityStateSplitEnabled && state === "California"
    ? `/dispensaries/${state.replace(/\s+/g, "-").toLowerCase()}/${city
        .replace(/\s+/g, "-")
        .toLowerCase()}${strainQueryParams}`
    : `/dispensaries${strainQueryParams}`;
};

export default useDispensariesLink;
